
const instructor = [
    {
        id: '1',
        img: 'assets/images/users/48/avatar-2.jpg',
        name: 'Bethany Nienow',
        course: '236',
        rate: '4.9'
    },
    {
        id: '2',
        img: 'assets/images/users/48/avatar-7.jpg',
        name: 'Sonia Conn',
        course: '247',
        rate: '4.8'
    },
    {
        id: '3',
        img: 'assets/images/users/48/avatar-4.jpg',
        name: 'Talon Bradtke',
        course: '365',
        rate: '4.9'
    },
    {
        id: '4',
        img: 'assets/images/users/48/avatar-5.jpg',
        name: 'Tyrell Kerluke',
        course: '298',
        rate: '4.7'
    },
    {
        id: '5',
        img: 'assets/images/users/48/avatar-6.jpg',
        name: 'Ross Zieme',
        course: '196',
        rate: '4.9'
    },
    {
        id: '6',
        img: 'assets/images/users/48/avatar-1.jpg',
        name: 'Hollis Spencer',
        course: '321',
        rate: '4.7'
    },
    {
        id: '7',
        img: 'assets/images/users/48/avatar-8.jpg',
        name: 'Cordia Grady',
        course: '357',
        rate: '4.8'
    }
]

const recentcourse = [
    {
        id: '1',
        img: 'assets/images/learning/react.png',
        name: 'Advanced React and Redux',
        category: 'React Development',
        instructor: 'Ayaan Bowen',
        lession: '15',
        duration: '2 Years',
        fees: '$278.12',
        status: 'Open',
        rating: '4.5'
    },
    {
        id: '2',
        img: 'assets/images/learning/shopify.png',
        name: 'The Complete Shopify Dropship course',
        category: 'Shopify Development',
        instructor: 'Jansh Brown',
        lession: '27',
        duration: '6 Months',
        fees: '$149.00',
        status: 'Open',
        rating: '4.5'
    },
    {
        id: '3',
        img: 'assets/images/learning/sketch.png',
        name: 'UI/UX Style guide With Sketch',
        category: 'Graphic Design',
        instructor: 'Ayaan Bowen',
        lession: '16',
        duration: '3 Months',
        fees: '$215.00',
        status: 'Close',
        rating: '4.9'
    },
    {
        id: '4',
        img: 'assets/images/learning/webpack.png',
        name: 'Digital Marketing',
        category: 'Marketing & Management',
        instructor: 'Prezy Mark',
        lession: '65',
        duration: '2 Years',
        fees: '$199.00',
        status: 'Open',
        rating: '4.3'
    },
    {
        id: '5',
        img: 'assets/images/learning/laravel.png',
        name: 'Master Laravel for Beginners & Intermediate',
        category: 'Laravel Development',
        instructor: 'Nelson Schaden',
        lession: '21',
        duration: '8 Months',
        fees: '$379.99',
        status: 'Close',
        rating: '4.7'
    },
    {
        id: '6',
        img: 'assets/images/learning/tailwindcss.png',
        name: 'Tailwind CSS From Scratch',
        category: 'Web Design',
        instructor: 'Domenic Dach',
        lession: '53',
        duration: '1 Months',
        fees: '$473.08',
        status: 'Open',
        rating: '4.8'
    }
]
const category = [
    {
        id: '1',
        img: 'assets/images/learning/react.png',
        name: 'React Development',
        course: '250',
        color: 'info'
    },
    {
        id: '2',
        img: 'assets/images/learning/flask.png',
        name: 'Flask Development',
        course: '120',
        color: 'dark'
    },
    {
        id: '3',
        img: 'assets/images/learning/shopify.png',
        name: 'Shopify Development',
        course: '65',
        color: 'success'
    },
    {
        id: '4',
        img: 'assets/images/brands/firefox.png',
        name: 'Marketing & Management',
        course: '50',
        color: 'danger'
    },
    {
        id: '5',
        img: 'assets/images/learning/tailwindcss.png',
        name: 'Web Design',
        course: '345',
        color: 'info'
    },
    {
        id: '6',
        img: 'assets/images/learning/core.png',
        name: 'ASP.NET Development',
        course: '69',
        color: 'primary'
    },
    {
        id: '7',
        img: 'assets/images/learning/laravel.png',
        name: 'Laravel Development',
        course: '130',
        color: 'danger'
    },
    {
        id: '8',
        img: 'assets/images/learning/mysql.png',
        name: 'PHP Development',
        course: '25',
        color: 'primary'
    },
    {
        id: '9',
        img: 'assets/images/learning/sketch.png',
        name: 'Graphic Design',
        course: '25',
        color: 'warning'
    },
    {
        id: '10',
        img: 'assets/images/learning/symfony.png',
        name: 'Business & Consulting',
        course: '90',
        color: 'dark'
    },
    {
        id: '11',
        img: 'assets/images/learning/webpack.png',
        name: 'Digital Marketing',
        course: '75',
        color: 'info'
    },
    {
        id: '12',
        img: 'assets/images/brands/microsoft.png',
        name: 'Data Science',
        course: '69',
        color: 'success'
    },
    {
        id: '13',
        img: 'assets/images/brands/dribbble.png',
        name: 'Writing & Reading',
        course: '20',
        color: 'danger'
    },
    {
        id: '14',
        img: 'assets/images/brands/cloud-computing.png',
        name: 'Self Development',
        course: '10',
        color: 'info'
    },
    {
        id: '15',
        img: 'assets/images/brands/chrome.png',
        name: 'Computer Science',
        course: '10',
        color: 'warning'
    }
]

const instructorList = [
    {
        id: 1,
        img: "assets/images/users/32/avatar-10.jpg",
        name: "Domenic Dach",
        total_course: "356",
        email: "domenic@aldawal.com",
        experience: "9 Months",
        students: "320",
        contact: "+(532) 01523 14587",
        rating: "4.9",
        status: "Active"
    }, {
        id: 2,
        img: "assets/images/users/32/avatar-9.jpg",
        name: "Prezy Mark",
        total_course: "315",
        email: "prezy@aldawal.com",
        experience: "1 Years",
        students: "159",
        contact: "+(159) 65432 15987",
        rating: "4.8",
        status: "Unactive"
    }, {
        id: 3,
        img: "assets/images/users/32/avatar-8.jpg",
        name: "Nelson Schaden",
        total_course: "852",
        email: "nelson@aldawal.com",
        experience: "8 Months",
        students: "362",
        contact: "+(251) 12365 47896",
        rating: "4.2",
        status: "Active"
    }, {
        id: 4,
        img: "assets/images/users/32/avatar-7.jpg",
        name: "Deondre Huel",
        total_course: "485",
        email: "deondre@aldawal.com",
        experience: "3 Years",
        students: "321",
        contact: "+(025) 1592 15236",
        rating: "4.6",
        status: "Active"
    }, {
        id: 5,
        img: "assets/images/users/32/avatar-6.jpg",
        name: "Sarai Schmidt",
        total_course: "320",
        email: "sarai@aldawal.com",
        experience: "5 Years",
        students: "364",
        contact: "+(123) 01592 36544",
        rating: "4.7",
        status: "Active"
    }, {
        id: 6,
        img: "assets/images/users/32/avatar-5.jpg",
        name: "Ophelia Steuber",
        total_course: "485",
        email: "ophelia@aldawal.com",
        experience: "6 Years",
        students: "84",
        contact: "+(321) 01234 56987",
        rating: "4.4",
        status: "Unactive"
    }, {
        id: 7,
        img: "assets/images/users/32/avatar-4.jpg",
        name: "Nelson Schaden",
        total_course: "258",
        email: "nelson@aldawal.com",
        experience: "2 Years",
        students: "146",
        contact: "+(159) 98745 63210",
        rating: "4.8",
        status: "Active"
    }, {
        id: 8,
        img: "assets/images/users/32/avatar-3.jpg",
        name: "Zachary Stokes",
        total_course: "365",
        email: "zachary@aldawal.com",
        experience: "7 Months",
        students: "120",
        contact: "+(120) 12435 69870",
        rating: "4.9",
        status: "Active"
    }, {
        id: 9,
        img: "assets/images/users/48/avatar-2.jpg",
        name: "Ayaan Bowen",
        total_course: "162",
        email: "ayaan@aldawal.com",
        experience: "1 Years",
        students: "79",
        contact: "+(152) 15963 24785",
        rating: "4.7",
        status: "Unactive"
    }, {
        id: 10,
        img: "assets/images/users/32/avatar-1.jpg",
        name: "aldawal",
        total_course: "159",
        email: "aldawal@aldawal.com",
        experience: "2 Years",
        students: "49",
        contact: "+(123) 15962 32145",
        rating: "4.9",
        status: "Active"
    }, {
        id: 11,
        img: "assets/images/users/32/avatar-6.jpg",
        name: "Sarai Schmidt",
        total_course: "320",
        email: "sarai@aldawal.com",
        experience: "5 Years",
        students: "364",
        contact: "+(123) 01592 36544",
        rating: "4.7",
        status: "Active"
    }
]
const instructorGrid = [
    {
        id: 1,
        img: "assets/images/users/48/avatar-2.jpg",
        name: "Ayaan Bowen",
        total_course: "134",
        email: "ayaanbowen@aldawal.com",
        designation: "Shopify Development",
        contact: "+(152) 15963 24785",
        rating: "4.5",
        status: "Active",
        experience: "9 Months",
        students: "320",
    }, {
        id: 2,
        img: "assets/images/users/avatar-1.jpg",
        name: "Priscilla Takahashi",
        total_course: "160",
        email: "priscilla@aldawal.com",
        designation: "Project Manager",
        contact: "+(122) 0397 3076",
        rating: "4.8",
        status: "Active",
        experience: "1 Years",
        students: "159",
    }, {
        id: 3,
        img: "assets/images/users/avatar-3.jpg",
        name: "Martin Roth",
        total_course: "362",
        email: "martinroth@aldawal.com",
        designation: "Graphic Designer",
        contact: " 781 789 3874",
        rating: "4.3",
        status: "Active",
        experience: "8 Months",
        students: "362",
    }, {
        id: 4,
        img: "assets/images/users/avatar-4.jpg",
        name: "Jennifer Masten",
        total_course: "241",
        email: " jennifermasten@aldawal.com",
        designation: "React Development",
        contact: "918 664 0738",
        rating: "4.6",
        status: "Active",
        experience: "3 Years",
        students: "321",
    }, {
        id: 5,
        img: "assets/images/users/avatar-5.jpg",
        name: "Hazel Gordon",
        total_course: "237",
        email: "hazelgordon@aldawal.com",
        designation: "Laravel Development",
        contact: "617 398 3263",
        rating: "4.8",
        status: "Unactive",
        experience: "5 Years",
        students: "364",
    }, {
        id: 6,
        img: "assets/images/users/avatar-8.jpg",
        name: "Michael Johnson",
        total_course: "174",
        email: "michaeljohnson@aldawal.com",
        designation: "Flask Development",
        contact: "02261 95 80 88",
        rating: "4.7",
        status: "Active",
        experience: "6 Years",
        students: "84",
    }, {
        id: 7,
        img: "assets/images/users/avatar-6.jpg",
        name: "Angela Fryar",
        total_course: "99",
        email: "angelafryar@aldawal.com",
        designation: "Web Designer",
        contact: " 089 54 77 91",
        rating: "4.9",
        status: "Active",
        experience: "2 Years",
        students: "146",
    }, {
        id: 8,
        img: "assets/images/users/avatar-7.jpg",
        name: "Anthony Gardner",
        total_course: "110",
        email: "anthonygardner@aldawal.com",
        designation: "Marketing & Management",
        contact: " 09404 91 69 16",
        rating: "4.6",
        status: "Active",
        experience: "7 Months",
        students: "120",
    }, {
        id: 9,
        img: "assets/images/users/avatar-9.jpg",
        name: "James Bradley",
        total_course: "159",
        email: "jamesbradley@aldawal.com",
        designation: "Marketing & Management",
        contact: "040 67 58 18",
        rating: "4.3",
        status: "Active",
        experience: "1 Years",
        students: "79",
    }, {
        id: 10,
        img: "assets/images/users/avatar-10.jpg",
        name: "Brenda Cornett",
        total_course: "176",
        email: "brendacornett@aldawal.com",
        designation: "Marketing & Management",
        contact: " 03586 68 04 69",
        rating: "4.3",
        status: "Active",
        experience: "2 Years",
        students: "49",
    }, {
        id: 11,
        img: "assets/images/users/avatar-6.jpg",
        name: "Sarai Schmidt",
        total_course: "320",
        email: "sarai@aldawal.com",
        designation: "364",
        contact: "+(123) 01592 36544",
        rating: "4.7",
        status: "Active",
        experience: "5 Years",
        students: "364",
    }
]

export { instructor, recentcourse, category, instructorList, instructorGrid }